(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const enhance = (root) => {
    const scopes = [];

    if (root.matches?.('[data-s911-aplus]')) scopes.push(root);
    root.querySelectorAll?.('[data-s911-aplus]').forEach((scope) => scopes.push(scope));

    scopes.forEach((scope) => {
      if (scope.dataset.s911Enhanced === 'true') return;
      scope.dataset.s911Enhanced = 'true';

      const revealItems = [...scope.querySelectorAll('[data-s911-reveal]')];
      const videos = [...scope.querySelectorAll('[data-s911-lazy-video]')];

      if (reduceMotion.matches || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        );

        revealItems.forEach((item) => revealObserver.observe(item));
      }

      if (!reduceMotion.matches && 'IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;

              if (entry.isIntersecting) {
                if (!video.src && video.dataset.src) {
                  video.src = video.dataset.src;
                  video.muted = true;
                  video.defaultMuted = true;
                  video.load();
                }
                video.play().catch(() => {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { rootMargin: '360px 0px', threshold: 0.01 }
        );

        videos.forEach((video) => videoObserver.observe(video));
      }

      scope.querySelectorAll('[data-s911-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-s911-carousel-track]');
        const previous = carousel.querySelector('[data-s911-carousel-prev]');
        const next = carousel.querySelector('[data-s911-carousel-next]');

        if (!track || !previous || !next) return;

        const updateControls = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        };

        const move = (direction) => {
          track.scrollBy({
            left: direction * Math.max(280, track.clientWidth * 0.82),
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
          });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
        updateControls();
      });

      scope.querySelectorAll('[data-s911-buy]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const buyBox = document.querySelector('#s911-buy-box');
          if (!buyBox) return;
          event.preventDefault();
          buyBox.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
  };

  const init = () => enhance(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
